export let PREVIEW_TYPES;
(function (PREVIEW_TYPES) {
  PREVIEW_TYPES["FIRST_20_SEC"] = "first-20-sec";
  PREVIEW_TYPES["TRAILER"] = "trailer";
  PREVIEW_TYPES["AUTOGENERATED"] = "autogenerated";
  PREVIEW_TYPES["NONE"] = "none";
})(PREVIEW_TYPES || (PREVIEW_TYPES = {}));
//# sourceMappingURL=preview-types.js.map